import ReactDOM from "react-dom/client";
import App from "./layout/App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@redux/store";
import { createGlobalStyle } from "styled-components";
import { DebugErrorBoundary } from "./DebugErrorBoundary";
import reportWebVitals from "./reportWebVitals";

const GlobalStyle = createGlobalStyle`
  @supports (-webkit-touch-callout: none) {
    input,
    textarea,
    select,
    button,
    label {
      font-size: 16px !important;
    }
  }
`;

const rootElement = document.getElementById("root");

if (rootElement) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<BrowserRouter>
			<Provider store={store}>
        <DebugErrorBoundary>
          <GlobalStyle />
          <App />
        </DebugErrorBoundary>
			</Provider>
		</BrowserRouter>
	);
}

reportWebVitals();
